import React, { useEffect, useState } from 'react';
import AppHeader from '../../../components/Dashboard/AppHeader';
import { Content } from 'antd/es/layout/layout';
import { Avatar, Input, Table, Spin, message } from 'antd';
import { SearchOutlined } from "@ant-design/icons";

const TeacherDetails = () => {
    const [teachers, setTeachers] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(5);
    const [totalPages, setTotalPages] = useState(1);

    const fetchTeachers = async (search = '', page = 1, limit = 5) => {
        setLoading(true);
        try {
            const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/getTeacAndStuDetails/teacher?page=${page}&limit=${limit}&search=${search}`);
            const json = await res.json();

            const formatted = json.data.map((item) => ({
                key: item._id,
                name: item.fullName,
                subject: item.courseName,
                email: item.email,
                profilePic: item.profilePic
                // contact: item.contactNumber,
                // actions: item.someActionMetric || 0 // Replace with real field if needed
            }));

            setTeachers(formatted);
            setTotalPages(json.totalPages || 1);
        } catch (err) {
            message.error('Failed to fetch teacher data.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTeachers(searchText, currentPage, pageSize);
    }, [searchText, currentPage, pageSize]);

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
        setCurrentPage(1);
    };

    const handleTableChange = (pagination) => {
        setCurrentPage(pagination.current);
        setPageSize(pagination.pageSize);
    };

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => (
                <div className="flex items-center">
                    <Avatar className="mr-2" src={record.profilePic} />
                    {text}
                </div>
            ),
        },
        { title: 'Subject', dataIndex: 'subject', key: 'subject' },
        { title: 'Email', dataIndex: 'email', key: 'email' },
        // { title: 'Contact', dataIndex: 'contact', key: 'contact' },
        // { title: 'Actions', dataIndex: 'actions', key: 'actions' }
    ];

    return (
        <Content>
            <AppHeader title={'Teacher Details'} content={'Purpose: View, edit, or delete teacher profiles.'} />
            <h3 className="text-xl font-semibold mb-4">Details of Teachers</h3>
            <div className="border-[2px] border-[black] rounded-[10px] p-3">
                <div className="mb-4 flex space-x-2">
                    <Input
                        placeholder="Search by teacher name or subject"
                        value={searchText}
                        onChange={handleSearchChange}
                        className="max-w-72 border-2 border-solid border-black"
                        suffix={<SearchOutlined className="text-gray-500" />}
                    />
                </div>
                {loading ? (
                    <Spin />
                ) : (
                    <Table
                        columns={columns}
                        dataSource={teachers}
                        pagination={{
                            current: currentPage,
                            pageSize: pageSize,
                            total: totalPages * pageSize,
                            showSizeChanger: true,
                            pageSizeOptions: ['5', '10', '20']
                        }}
                        onChange={handleTableChange}
                        scroll={{ x: 'max-content' }}
                        size="small"
                        responsive
                        className='custom-table'
                    />
                )}
            </div>

            {/* Teacher Profile Screen (static for now) */}
            <h3 className="text-xl font-semibold my-4">Teacher Profile Screen</h3>
            <div className="border-[2px] border-[black] rounded-[10px] p-5 flex flex-col md:flex-row items-center">
                <div className="flex items-center space-x-4 md:w-1/3">
                    <Avatar size={80} src="https://i.pravatar.cc/150?u=charlie.rawal" />
                    <div>
                        <div className="text-lg font-bold">Charlie Rawal</div>
                        <div className="text-gray-500">charlierawal@gmail.com</div>
                    </div>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-3 py-5 gap-4 my-4 md:mt-0 md:w-2/3">
                    <div className="flex flex-col">
                        <label className="text-black text-normal mb-3">Full Name</label>
                        <Input value="Charlie Rawal" disabled className="bg-gray-100 border-2 py-2 max-w-64" />
                    </div>
                    <div className="flex flex-col">
                        <label className="text-black text-normal mb-3">Subject</label>
                        <Input value="22" disabled className="bg-gray-100 border-2 py-2 max-w-64" />
                    </div>
                    <div className="flex flex-col">
                        <label className="text-black text-normal mb-3">Email</label>
                        <Input value="rawalsingh@gmail.com" disabled className="bg-gray-100 border-2 py-2 max-w-64" />
                    </div>
                    <div className="flex flex-col">
                        <label className="text-black text-normal mb-3">GRADE</label>
                        <Input value="100/72" disabled className="bg-gray-100 border-2 py-2 max-w-64" />
                    </div>
                    <div className="flex flex-col">
                        <label className="text-black text-normal mb-3">Contact</label>
                        <Input value="0000 000 0000" disabled className="bg-gray-100 border-2 py-2 max-w-64" />
                    </div>
                    <div className="flex flex-col">
                        <label className="text-black text-normal mb-3">Actions</label>
                        <Input value="250" disabled className="bg-gray-100 border-2 py-2 max-w-64" />
                    </div>
                </div>
            </div>
        </Content>
    );
};

export default TeacherDetails;
